import Dialog from '@anm/components/modals/Dialog';
import ConfirmDelete from '@anm/components/notification/ConfirmDelete';
import useEventPending from '@anm/hooks/useEventPending';
import noop from 'lodash/fp/noop';
import { useCallback, FC } from 'react';

import withVideoFolder, { WithVideoFolder } from '../../../../HOCs/withVideoFolder';

import { useDecrementEmbedStats } from './hooks';

type HOCs = WithVideoFolder;

export type DeleteProjectModalProps = {
  projectId: string;
  onClose?: () => void;
  onDelete?: () => void;
};

const DeleteProjectModal: FC<HOCs & DeleteProjectModalProps> = ({
  projectId,
  videoFolder,
  deleteProject,
  onClose = noop,
  onDelete = noop
}) => {
  const statEventPending = useEventPending(videoFolder.deleteProject.isPending, onDelete);

  const handleDecrementEmbedStats = useDecrementEmbedStats(projectId);

  const handleDeleteProject = useCallback(() => {
    deleteProject(projectId);
    statEventPending();
    handleDecrementEmbedStats();
  }, []);

  return (
    <Dialog onModalClose={onClose} onSubmit={handleDeleteProject}>
      <ConfirmDelete
        isPending={videoFolder.deleteProject.isPending}
        deleteItemName="video"
        onClose={onClose}
        onDelete={handleDeleteProject}
      />
    </Dialog>
  );
};

export default withVideoFolder(DeleteProjectModal);
